import { PAPER_WHITE_AVATAR_HUE } from "../../shared/game";

export const DEFAULT_CAPY_SHIELD_HUE = 184;

export type CapyShieldElementOptions = {
    ariaHidden?: boolean;
    className?: string;
    hue?: number | null;
};

const joinClassNames = (...classNames: Array<string | undefined>): string =>
    classNames.filter((className): className is string => Boolean(className?.trim())).join(" ");

export const setCapyShieldHue = (element: HTMLElement, hue: number | null | undefined) => {
    const normalizedHue = typeof hue === "number" && Number.isFinite(hue) ? hue : DEFAULT_CAPY_SHIELD_HUE;
    const isPaperWhite = normalizedHue === PAPER_WHITE_AVATAR_HUE;

    element.classList.toggle("is-paper-white", isPaperWhite);
    if (isPaperWhite) {
        element.style.removeProperty("--playground-avatar-hue");
    } else {
        element.style.setProperty("--playground-avatar-hue", String(normalizedHue));
    }
};

/**
 * Reuses the waiting-room Capy Shield paint layers without carrying over its
 * square movement/contact behavior. The legacy class names remain on the
 * layers so the established face can move across modes without visual drift.
 */
export const createCapyShieldElement = (options: CapyShieldElementOptions = {}): HTMLSpanElement => {
    const element = document.createElement("span");
    const ears = document.createElement("span");
    const shield = document.createElement("span");
    const muzzle = document.createElement("span");

    element.className = joinClassNames("lobby-playground-square", "capy-shield", options.className);
    ears.className = "lobby-playground-capy-ears capy-shield-ears";
    shield.className = "lobby-playground-capy-shield capy-shield-face";
    muzzle.className = "lobby-playground-capy-muzzle capy-shield-muzzle";
    element.setAttribute("aria-hidden", options.ariaHidden === false ? "false" : "true");
    element.append(ears, shield, muzzle);
    if (Object.hasOwn(options, "hue")) {
        setCapyShieldHue(element, options.hue);
    }

    return element;
};
